import script from "./NotificationsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsDrawer.vue?vue&type=style&index=0&id=28d558b1&lang=less&scoped=true"
import "./NotificationsDrawer.vue?vue&type=style&index=1&id=28d558b1&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d558b1"]])

export default __exports__